import { createContext } from 'react';
import { Category, CategoryProduct } from '../../types/categoryTypes';
import { HomeProduct } from '../../types/productTypes';

export type CategoryContextProps = {
	categories: Array<Category>;
	productDetails: Array<CategoryProduct>;
	getCategories: Function;
	getCategory: Function;
	getHomeProducts: Function;
	getProductVariantsByProvider: Function;
	// ToDo: enable this when the backend is ready for credit
	// getFinancialProviders: Function;
	products: Array<HomeProduct>;
	setProducts: Function;
};

const CategoryContext = createContext({} as CategoryContextProps);

export default CategoryContext;
